import {
  BULK_CHANGES_REQUEST,
  BULK_CHANGES_ERROR,
  BULK_CHANGES_SUCCESS
} from './constants';
import { BASE_URL, UUID } from '../../../middleware/api';
import { BULK_CHANGES } from '../../../services/ApiEndpointsConstants';

export const setBulkChanges = (imagesObject) => {
  return async (dispatch) => {
    const token = localStorage.getItem(UUID) || null;

    dispatch({ type: BULK_CHANGES_REQUEST });

    let selected = null;

    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(imagesObject)
    };

    try {
      const response = await fetch(
        `${BASE_URL}${BULK_CHANGES}`,
        requestOptions
      );
      const result = await response?.json();
      selected = result;
    } catch (error) {
      console.error('Error fetching photos data from the server', error);
    }

    if (!selected) {
      dispatch({ type: BULK_CHANGES_ERROR });
    }

    return dispatch({
      type: BULK_CHANGES_SUCCESS
    });
  };
};
